"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _freeze = require("babel-runtime/core-js/object/freeze");

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * Enumeration of values. Often used to describle possible values of a state
 * variable.
 */
var Enum = function () {
  function Enum(values /*: string[]*/) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Enum);

    this._values = values;
    this.length = this._values.length;
    this._values.forEach(function (value, index) {
      return _this[value] = index;
    });

    (0, _freeze2.default)(this);
  }

  /**
   * Returns the maximum possible value for the Enum.
   * @return Biggest value in the Enum. (Last one)
   */


  (0, _createClass3.default)(Enum, [{
    key: "getMax",
    value: function getMax() /*: number*/ {
      return this.length - 1;
    }

    /**
     * Get the strings that constitute the Enum.
     * @return The original Array provided to create the Enum.
     */

  }, {
    key: "getList",
    value: function getList() /*: string[]*/ {
      return this._values;
    }

    /**
     * Returns the mapping between the original Array provided to create the Enum
     * and the associated numerical value.
     * @return A map from strings to numbers.
     */

  }, {
    key: "getMapping",
    value: function getMapping() /*: {[id:string]: number}*/ {
      var _this2 = this;

      return this._values.reduce(function (values, value) {
        values[value] = _this2[value];

        return values;
      }, {});
    }
  }, {
    key: "getValues",


    /**
     * Returns the list of possible numerical values for the Enum.
     * @return All possible numerical value for the Enum.
     */
    value: function getValues() /*: number[]*/ {
      var _this3 = this;

      return this._values.map(function (value) {
        return _this3[value];
      });
    }
  }]);
  return Enum;
}();

exports.default = Enum;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/utilities/types/Enum.js
// module id = 5
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54